import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=78311362"
import script from "./roadmap.vue?vue&type=script&lang=js"
export * from "./roadmap.vue?vue&type=script&lang=js"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=78311362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports